module.exports = __webpack_public_path__ + "static/media/flask-red.deddd5c2.svg";